(() => {
  'use strict';
  document.addEventListener('submit', async event => {
    const form = event.target.closest('[data-mz-card-purchase]');
    if (!form) return;
    event.preventDefault();
    event.stopPropagation();
    const button = form.querySelector('button');
    if (button.disabled) return;
    const status = form.querySelector('[role="status"]');
    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    status.textContent = '';
    form.classList.add('is-feedback');
    document.dispatchEvent(new CustomEvent('theme:loading:start'));
    try {
      const response = await fetch(form.action + '.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ id: form.elements.id.value, quantity: 1 })
      });
      const result = await response.json();
      if (!response.ok) throw new Error(result.description || 'Unable to add this item. Please try again.');
      if (window.theme && window.theme.pageType !== 'cart' && document.getElementById('sidebar-cart')) {
        form.dispatchEvent(new CustomEvent('product:added', { bubbles: true, detail: { variant: result, quantity: 1 } }));
      } else {
        window.location.assign(window.routes ? window.routes.cartUrl : '/cart');
      }
    } catch (error) {
      status.textContent = error.message || 'Unable to add this item. Please try again.';
    } finally {
      button.disabled = false;
      button.removeAttribute('aria-busy');
      document.dispatchEvent(new CustomEvent('theme:loading:end'));
      if (!status.textContent) form.classList.remove('is-feedback');
    }
  });
})();

